import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useFixedCouponSno } from '../../../hooks/useFixedCouponSno';
import { queryKey } from '../../../constant/queryKey';

export const useGoodsCouponList = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  return useQuery({
    queryKey: queryKey.goodsCouponList(goodsSno, fixedCouponSno),
    queryFn: () => goodsService.getGoodsCoupons(goodsSno, fixedCouponSno),
    select: data => {
      const marketCoupons = data.filter(coupon => coupon.applicable_type === 2);
      const cartCoupons = data.filter(coupon => coupon.applicable_type !== 2);
      return {
        allCoupons: data,
        cartCoupons,
        marketCoupons,
      };
    },
  });
};
